// Adding venue IDs for testing environments: https://resy.atlassian.net/browse/CON-13134 */
const getUSOpenVenueID = () => {
  if (ENV === 'staging' || ENV === 'dev') {
    return 1314760;
  }

  if (ENV === 'demo') {
    return 1314760;
  }

  if (ENV === 'sandbox') {
    return 200000079;
  }

  if (ENV === 'prod') {
    return 53140;
  }

  return null;
};

export default getUSOpenVenueID;
